module.exports = __webpack_public_path__ + "img/shipo-map-barge-status.1eab06aa.svg";